import React from 'react';

import { useHomeData } from './home/useHomeData';
import HomeView from './home/HomeView';

export default function Home() {
  const data = useHomeData();
  return <HomeView {...data} />;
}
 
